// extracted by mini-css-extract-plugin
export default {"toaster":"styles_toaster__oRygI"};